import script from "./ModalCamposPreenchidos.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalCamposPreenchidos.vue?vue&type=script&setup=true&lang=js"

import "./ModalCamposPreenchidos.vue?vue&type=style&index=0&id=4a67f03f&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4a67f03f"]])

export default __exports__